import type { OrganizationPlanType } from '../types';

/**
 * Legacy team experience (seats / old billing). New plans use credits, API key limits, etc.
 * Missing or unknown planType is treated as legacy for safe fallback.
 */
export default function isLegacyOrganizationPlan(
  planType: OrganizationPlanType | string | undefined | null,
): boolean {
  if (planType == null || planType === '') {
    return true;
  }
  return (
    planType === 'legacy_free' ||
    planType === 'legacy_pro' ||
    planType === 'legacy_unlimited'
  );
}
